<template>
  <div class="post" @click="goToPost">
    <div class="by"><leech-logo :color="iconHexColor"></leech-logo></div>
    <div class="block">
      <div class="creation">
        {{ createdDateTime }} - {{ createdByUserName }}
      </div>
      <div class="content">{{ commentText }}</div>
    </div>
  </div>
</template>
<script>
import LeechLogo from "./LeechLogo.vue";

export default {
  components: {
    LeechLogo,
  },
  props: {
    forumPostCommentId: Number,
    commentText: String,

    iconHexColor: String,

    createdDateTime: String,
    createdByUserName: String,
  },
};
</script>
<style lang="scss" scoped>
.post {
  max-width: calc(100% - 30px);
  width: 1000px;
  background-color: #ffffff;
  box-shadow: 0 0 10px #999999;
  box-sizing: border-box;
  border-radius: 12px;
  padding: 10px;
  border-radius: 6px;
  margin-bottom: 30px;
  position: relative;

  transition: box-shadow 0.2s, width 0.2s;

  .by {
    position: absolute;
    top: 5px;
    left: -70px;
    height: 60px;
    width: 60px;
    padding: 5px;
    box-sizing: border-box;
    border-radius: 50%;
    background-color: #ffffff;
    box-shadow: 0 0 10px #999999;
  }

  .block {
    width: 100%;

    .creation {
      font-size: 13px;
      font-style: italic;
      color: #666666;
    }

    .content {
      padding: 20px 10px;
      font-size: 14px;
      font-weight: bold;
      white-space: pre-wrap;
    }
  }
}

@media only screen and (max-width: 1150px) {
  .post {
    margin: 80px 0 20px;

    .by {
      top: -70px;
      left: 5px;
    }
  }
}
</style>
